export const filterSystemAndCurrentUser = function (users, currentProfile) {
  if (!users || !currentProfile) return [];

  return users.filter(user => !user.isSystemUser && !matchingUsers(user, currentProfile));
};

// Coerce both sides to string: socket payloads may carry raw numbers while
// Ember Data attributes store strings, and strict equality would miss matches.
export const matchingUsers = function (userA, userB) {
  if (!userA || !userB) return false;

  return (
    String(userA.externalId) === String(userB.externalId) &&
    String(userA.externalScope) === String(userB.externalScope)
  );
};
